import { Link } from "react-router-dom";

const renderPageNumbersMobile = (
    totalPages: number,
    pageIndex: number,
    setPageIndex: any
  ) => {
    const pages = [];
  
    if (totalPages === 1) {
      pages.push(
        <li key={0} className="page-item">
          <Link
            to="#"
            className="page-link active"
            onClick={() => setPageIndex(0)}
          >
            1
          </Link>
        </li>
      );
      return pages;
    }
  
    pages.push(
      <li key={0} className="page-item">
        <Link
          to="#"
          className={pageIndex === 0 ? "page-link active" : "page-link"}
          onClick={() => setPageIndex(0)}
        >
          1
        </Link>
      </li>
    );
  
    if (pageIndex === 1) {
      pages.push(
        <li key={1} className="page-item">
          <Link
            to="#"
            className="page-link active"
            onClick={() => setPageIndex(1)}
          >
            2
          </Link>
        </li>
      );
  
      if (totalPages > 3) {
        pages.push(
          <li key="dots-end" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
    } else if (pageIndex === totalPages - 2) {
      if (totalPages > 3) {
        pages.push(
          <li key="dots-start" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
  
      pages.push(
        <li key={totalPages - 2} className="page-item">
          <Link
            to="#"
            className="page-link active"
            onClick={() => setPageIndex(totalPages - 2)}
          >
            {totalPages - 1}
          </Link>
        </li>
      );
    } else {
      if (pageIndex > 3) {
        pages.push(
          <li key="dots-start" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
  
      if (pageIndex > 1 && pageIndex < totalPages - 2) {
        pages.push(
          <li key={pageIndex} className="page-item">
            <Link
              to="#"
              className="page-link active"
              onClick={() => setPageIndex(pageIndex)}
            >
              {pageIndex + 1}
            </Link>
          </li>
        );
      }
  
      if (pageIndex < totalPages - 4) {
        pages.push(
          <li key="dots-end" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
    }
  
    pages.push(
      <li key={totalPages - 1} className="page-item">
        <Link
          to="#"
          className={
            pageIndex === totalPages - 1 ? "page-link active" : "page-link"
          }
          onClick={() => setPageIndex(totalPages - 1)}
        >
          {totalPages}
        </Link>
      </li>
    );
  
    return pages;
  };
  
  export default renderPageNumbersMobile;